import React, { useEffect } from "react"
import { useTransitionState } from 'gatsby-plugin-transition-link/hooks'
import gsap from "gsap"
import "./m-t-c.css"

const MainTransitionContainer = ({id, children}) => {

    const { transitionStatus } = useTransitionState();

    useEffect(() => {
        let objs = document.querySelectorAll(`.${id}.t-link-fading`);
        if (transitionStatus === 'entering' || transitionStatus === 'entered') {
            if (objs) {
                gsap.to(objs, {
                    duration: 0.3,
                    delay: 0.1,
                    opacity: 1,
                    y: 0,
                    ease: "power4",
                });
            }
        }
        if (transitionStatus === 'exiting') {
            if (objs) {
                gsap.to(objs, {
                    duration: 0.3,
                    opacity: 0,
                    ease: "power4",
                    y: 5,
                    stagger: 0
                });
            }
        }
    }, [transitionStatus]);

    return (
        <main className={`${id} t-link-fading`} data-x-fade={true}>
            {children}
        </main>
    )

}

export default MainTransitionContainer;